import { useCallback, useMemo } from "react";
import ClickPopover from "./ClickPopover";
import { TextInput } from "./TextInput";
import Big from "big.js";

export type DimensionsAndWeight = {
  weight: number;
  size1: number;
  size2: number;
  size3: number;
};

export function DimensionsAndWeightPopover({
  dimensionsAndWeight,
  onChange,
}: {
  dimensionsAndWeight: DimensionsAndWeight;
  onChange: (dimensionsAndWeight: DimensionsAndWeight) => void;
}) {

  const onChangeHandler = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const newDimensionsAndWeight = {
      ...dimensionsAndWeight,
      [e.target.name]: parseFloat(e.target.value),
    };

    const sizes = [newDimensionsAndWeight.size1, newDimensionsAndWeight.size2, newDimensionsAndWeight.size3];
    sizes.sort((a, b) => b - a);

    newDimensionsAndWeight.size1 = sizes[0];
    newDimensionsAndWeight.size2 = sizes[1];
    newDimensionsAndWeight.size3 = sizes[2];

    onChange(newDimensionsAndWeight);
  }, [dimensionsAndWeight, onChange]);

  const volumeWeight = useMemo(() => {
    return new Big(dimensionsAndWeight.size1).times(dimensionsAndWeight.size2).times(dimensionsAndWeight.size3).times(1000).div(5000).round(0).toNumber();
  }, [dimensionsAndWeight]);
  return (
    <ClickPopover
      content={
        <div className="flex flex-col gap-2">
          <TextInput
            label="Size 1"
            name="size1"
            type="number"
            step="1"
            defaultValue={dimensionsAndWeight.size1}
            onBlur={onChangeHandler}
          />
          <TextInput
            label="Size 2"
            name="size2"
            type="number"
            step="1"
            defaultValue={dimensionsAndWeight.size2}
            onBlur={onChangeHandler}
          />
          <TextInput
            label="Size 3"
            name="size3"
            type="number"
            step="1"
            defaultValue={dimensionsAndWeight.size3}
            onBlur={onChangeHandler}
          />
          <TextInput
            label="Weight"
            name="weight"
            type="number"
            step="1"
            defaultValue={dimensionsAndWeight.weight}
            onBlur={onChangeHandler}
          />
        </div>
      }
    >
      <p className="text-lg text-gray-900">
        {dimensionsAndWeight.size1} x {dimensionsAndWeight.size2} x {dimensionsAndWeight.size3} cm
        <br/>{dimensionsAndWeight.weight} grams
        <br/>{volumeWeight} volume grams
      </p>
    </ClickPopover>
  );
}